//region :: Imports ::
import React, {createRef, ReactElement, RefObject} from 'react';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import MForm from '../../Toolkit/Components/Controls/Form';
import MPage, {MPageProps} from '../../Toolkit/Components/Shell/Page';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import MComponent from '../../Toolkit/Components/Component';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import MFormSection from '../../Toolkit/Components/Controls/FormSection';
import {MFormOutcome} from '../../Toolkit/Components/Controls/Form';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import withRouter from '../../Toolkit/WithRouter';
import {FieldProps, FormikHelpers} from 'formik';
import * as Yup from 'yup';
import NSwagAdapter from '../../Toolkit/Api/NSwagAdapter';
import {RequestClient, UpdateRequestRequest} from '../../Api/RequestClients';
import MNSwagClientConfiguration from '../../Toolkit/Api/NSwagClientConfiguration';
import TrafficManagementAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';
import {MNullable, toErrorMessage} from '../../Toolkit/Utils';
import {CreateRequestReply, CreateRequestValidator, RequestReply} from '../../Api/ControllerTypes/RequestTypes';
import MAlertDialog from '../../Components/Toolkit/AlertDialog';
import MFormFieldControl from '../../Toolkit/Components/Controls/FormFieldControl';
import MTextBox from '../../Toolkit/Components/Controls/TextBox';
import {Request} from '../../Api/ControllerTypes/RequestTypes';
import MNumericBox from '../../Components/Toolkit/NumericBox';
import MTextArea from '../../Toolkit/Components/Controls/TextArea';
import MDropDown from '../../Toolkit/Components/Controls/DropDown';
import MSaveButton from '../../Toolkit/Components/Controls/SaveButton';
import {MBackIconName, MNavigateToIconName, MSuccessIcon, MWarningIcon} from '../../Toolkit/Icons';
import MButton from '../../Toolkit/Components/Controls/Button';
import FileListControl from '../../Components/FileListControl';
import MAutoComplete from '../../Components/Toolkit/AutoComplete';
import EnumContext from '../../Context/enum-context';
import NoteListControl from '../../Components/NoteListControl';
import MCalendar from '../../Components/Toolkit/Calendar';
import {AddressReply} from '../../Api/ControllerTypes/LocationTypes';
import MNSwagReplyResult from '../../Toolkit/Api/NSwagReplyResult';
import {LocationClient} from '../../Api/LocationClient';
import {Project, ProjectMultiReply} from '../../Api/ControllerTypes/ProjectTypes';
import {ProjectClient} from '../../Api/ProjectClient';

//endregion

/** */
type RouteParams = {
    id: string;
};

/** */
enum PageActions {
    None = 0,
    Saving = 1
}

/** */
type Props = WithMsalProps & WithRouterProps<RouteParams> & {}

/** */
type State = {
    pageTitle: string;
    pageSubtitle: string;
    page: MPageProps;
    form: {
        id: string;
        data: Request;
        validationSchema: any;
    }
    pageActions: PageActions;
    projectList: Project[];
}

/** */
class CreateRequestPage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private m_newRequest: MNullable<CreateRequestReply> | undefined;
    private readonly m_routeParams: RouteParams;
    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_formRef: RefObject<MForm<FormData>>;
    private m_locationValue: string;
    private readonly m_requestClient: NSwagAdapter<RequestClient>;
    private readonly m_projectClient: NSwagAdapter<ProjectClient>;
    private readonly m_locationClient: NSwagAdapter<LocationClient>;
    private readonly m_alertDialogRef: RefObject<MAlertDialog>;
    
    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_routeParams = this.props.match.params;
        this.m_pageRef = createRef<MPage>();
        this.m_formRef = createRef<MForm<FormData>>();
        this.m_locationValue = '';
        this.m_requestClient = new NSwagAdapter<RequestClient>(new RequestClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_projectClient = new NSwagAdapter<ProjectClient>(new ProjectClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_locationClient = new NSwagAdapter<LocationClient>(new LocationClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));
        this.m_alertDialogRef = createRef<MAlertDialog>();

        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);
        this.close_Click = this.close_Click.bind(this);
        this.form_onBeforeSubmit = this.form_onBeforeSubmit.bind(this);
        this.form_onSubmit = this.form_onSubmit.bind(this);
        this.form_onAfterSubmit = this.form_onAfterSubmit.bind(this);
        this.form_onError = this.form_onError.bind(this);
        this.navigateToRequestButton_onClick = this.navigateToRequestButton_onClick.bind(this);
        this.isNavigateDisabled = this.isNavigateDisabled.bind(this);
        this.onNavigate_Click = this.onNavigate_Click.bind(this);
        this.getAddress_Click = this.getAddress_Click.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.openRecordButton_onClick = this.openRecordButton_onClick.bind(this);
        this.closeMessageButton_onClick = this.closeMessageButton_onClick.bind(this);

    }

    /** */
    private initializeState(): void {
        //  Page
        const page: MPageProps = {locked: false};

        const data: Request = {
            id: '',
            estimate: '',
            additionalRef: '',
            locked: false,
            requestor: '',
            exchange: '',
            slaType: -1,
            projectValue: -1,
            quoteStatus: 0,
            quoteCompleteDate: null,
            workStream: -1,
            costClaimable: -1,
            quoteValue: 0,
            jobPriority: -1,
            jobType: [-1],
            jobDetail: '',
            jobStatus: 0,
            workDescription: '',
            estimatedDays: 0,
            address1: '',
            address2: '',
            address3: '',
            city: '',
            county: '',
            postcode: '',
            northing: 0,
            easting: 0,
            gridReference: '',
            dueDate: null,
            slipNumber: '',
            jobStartDate: null,
            endType: 0,
            jobEndDate: null,
            selectedDays: [],
            noParkingRequired: false,
            weekendWorks: false,
            busStop: -1,
            dayOnly: false,
            civilsName: '',
            civilsEmail: '',
            civilsPhone: '',
            siteDocsComplete: false,
            invoiceNumber: '',
            parent: '',
            submittedDate: null,
            createdOn: null,
            addRecipients: '',
            permitRef: '',
            permitStatus: -1,
            drawingRef: '',
            resources: [],
            commercialStatus: 0,
            externalInvoicesReceived: 0,
            jobCompletedDate: null,
            commercialCompleteDate: null,
            dfeStatus: 0,
            worksTotalCost: 0,
            uplift: 0,
            dfeValue: 0,
            dfePartialReason: 0,
            dfePartialInfo: '',
            sentToDepotnet: false,
            actualCost: 0,
            drawingsBy: []
        };

        const validationSchema: any = Yup.object().shape({
            estimate: CreateRequestValidator.estimateFunc(this.m_requestClient, this.props.match.params.id),
            requestor: CreateRequestValidator.requestor,
            exchange: CreateRequestValidator.exchange,
            slaType: CreateRequestValidator.slaType,
            projectValue: CreateRequestValidator.projectValue,
            workStream: CreateRequestValidator.workStream,
            workDescription: CreateRequestValidator.workDescription,
            estimatedDays: CreateRequestValidator.estimatedDays,
            address1: CreateRequestValidator.address1,
            address2: CreateRequestValidator.address2,
            address3: CreateRequestValidator.address3,
            city: CreateRequestValidator.city,
            county: CreateRequestValidator.county,
            postcode: CreateRequestValidator.postcode,
            northing: CreateRequestValidator.northing,
            easting: CreateRequestValidator.easting,
            gridReference: CreateRequestValidator.gridReference,
            addRecipients: CreateRequestValidator.addRecipient
        });
        
        this.state = {
            pageTitle: '',
            pageSubtitle: '',
            page: page,
            form: {
                id: 'createRequestForm',
                data: data,
                validationSchema: validationSchema,
            },
            pageActions: PageActions.None,
            projectList: []
        };

    }

    public componentDidMount(): void {
        //Use the currently logged in user as the default requestor.
        const userName = this.props.msalContext.accounts[0].name;
        this.safeSetState((draft) => {
            draft.form.data.requestor = userName!;
        });
    }

    private form_onBeforeSubmit(fieldValues: Request, formikHelpers: FormikHelpers<Request>): boolean {
        this.safeSetState(draft => draft.pageActions = PageActions.Saving);
        return false;
    }

    private async form_onSubmit(fieldValues: Request, formikHelpers: FormikHelpers<Request>): Promise<void> {
        const updateRequest = new UpdateRequestRequest({
            id: fieldValues.id,
            estimate: fieldValues.estimate,
            additionalRef: fieldValues.additionalRef,
            exchange: fieldValues.exchange,
            slaType: fieldValues.slaType,
            projectValue: fieldValues.projectValue,
            quoteStatus: 0,
            workStream: fieldValues.workStream,
            costClaimable: -1,
            quoteValue: 0,
            jobPriority: -1,
            jobType: [],
            jobDetail: '',
            workDescription: fieldValues.workDescription,
            estimatedDays: fieldValues.estimatedDays,
            address1: fieldValues.address1,
            address2: fieldValues.address2,
            address3: fieldValues.address3,
            city: fieldValues.city,
            county: fieldValues.county,
            postcode: fieldValues.postcode,
            northing: fieldValues.northing,
            easting: fieldValues.easting,
            gridReference: fieldValues.gridReference,
            dueDate: fieldValues.dueDate ?? undefined,
            slipNumber: undefined,
            jobStartDate: undefined,
            endType: 0,
            jobEndDate: undefined,
            selectedDays: [],
            noParkingRequired: undefined,
            weekendWorks: undefined,
            busStop: undefined,
            dayOnly: undefined,
            civilsName: undefined,
            civilsEmail: undefined,
            civilsPhone: undefined,
            siteDocsComplete: false,
            jobStatus: 0,
            addRecipients: fieldValues.addRecipients?.trim().toLowerCase() ?? ''
        });

        const result = await this.m_requestClient.callWithReply(CreateRequestReply, (client => client.update(updateRequest)));

        this.m_newRequest = result.reply!;
    }

    private form_onAfterSubmit(outcome: MFormOutcome, fieldValues: Request, formikHelpers: FormikHelpers<Request>, exception: any | undefined): void {
        if(outcome === 'success') {
            if(this.m_newRequest?.estimateExists === null || this.m_newRequest?.estimateExists === undefined || this.m_newRequest?.estimateExists === "") {
                this.m_alertDialogRef.current!.show(
                    'Create TM CAD Request',
                    `A new request has been created for ${this.m_newRequest!.request?.estimate}.`,
                    MSuccessIcon,
                    <MButton label="Open request list"
                             color="success"
                             icon={MNavigateToIconName}
                             disabled={false}
                             onClick={this.navigateToRequestButton_onClick}/>);
            } else {
                //Request already exists.
                this.m_alertDialogRef.current!.show(
                    'TM CAD Request Already Exists',
                    `The requested Estimate already exists in the database. Do you wish to Open the existing record or Change the entered data?`,
                    MWarningIcon,
                    <React.Fragment>
                        <MButton label="Open Record"
                                 color="success"
                                 icon={MNavigateToIconName}
                                 disabled={false}
                                 onClick={this.openRecordButton_onClick}/>
                        <MSpacer/>
                        <MButton label="Change Data"
                                 color="success"
                                 icon={MNavigateToIconName}
                                 disabled={false}
                                 onClick={this.closeMessageButton_onClick}/>
                    </React.Fragment>);
            }

        }

        this.safeSetState((draft: State) => {

            draft.pageActions &= ~PageActions.Saving;
            draft.pageActions = PageActions.None;

        });
    }

    private navigateToRequestButton_onClick(): void {
        this.props.history.replace(`/requests`);
    }

    private openRecordButton_onClick(): void {
        this.props.navigate(`/requests/${this.m_newRequest?.estimateExists}`);
    }

    private closeMessageButton_onClick(): void {
        this.m_alertDialogRef.current!.hide();
    }

    private getAddress_Click(fieldProps: FieldProps): void {
        this.m_locationClient.callWithReply(AddressReply,
            (client) => client.bngToAddress(fieldProps.form.values.easting, fieldProps.form.values.northing))
            .then((reply: MNSwagReplyResult<AddressReply>) => {
                reply.throwIfFailed();

                let address = reply.reply;
                if(address!.address!.addressValid) {
                    fieldProps.form.setFieldValue("address1", address!.address!.address1 ?? '')
                    fieldProps.form.setFieldValue("address2", address!.address!.address2 ?? '')
                    fieldProps.form.setFieldValue("address3", address!.address!.address3 ?? '')
                    fieldProps.form.setFieldValue("city", address!.address!.city ?? '')
                    fieldProps.form.setFieldValue("county", address!.address!.county ?? '')
                    fieldProps.form.setFieldValue("postcode", address!.address!.postcode ?? '')
                } else {
                    alert("No street address can be found for the specified location!");
                }

            });
    }

    private form_onError(exception: any): boolean
    {
        const handled = false;
        this.m_pageRef.current!.messageBar.error(toErrorMessage(exception));
        return handled;
    }

    private async page_onLoadData(): Promise<void> {
        //Pull request data
        const id = this.props.match.params.id;
        const result = await this.m_requestClient.callWithReply(RequestReply, (client) => client.get(id));
        result.throwIfFailed();
        result.reply!.request!.gridReference = result.reply!.request!.gridReference ?? '';

        //Pull project data
        const projectResult = await this.m_projectClient.callWithReply(ProjectMultiReply, (client) => client.getAll());
        projectResult.throwIfFailed();

        this.safeSetState((draft) => {
            draft.form.data = result.reply!.request!;
            draft.pageTitle = 'Create TM CAD Request';
            draft.projectList = projectResult.reply!.projects!;
        });
    }

    private onSlaChange(fieldProps: FieldProps, newValue: MNullable<number>) {
        //filter days so any outside the new selection can be removed.
        let newDate = new Date();
        if(newValue === 2) {
            newDate.setDate(newDate.getDate() + 1);
        }
        if(newValue === 0 || newValue === 3) {
            newDate.setDate(newDate.getDate() + 3);
        }
        newDate!.setHours(0, 0, 0, 0);

        fieldProps.form.setFieldValue('dueDate', newDate!);
    }

    /** */
    private getToolbarTemplate(): ReactElement<MToolbar> {

        return (
            <MToolbar>
                <MButton label="Back"
                         color="secondary"
                         iconOnly={true}
                         icon={MBackIconName}
                         tooltip="Go Back"
                         disabled={false}
                         onClick={this.close_Click}/>

                <MSpacer/>
                <MSaveButton formId={this.state.form.id}
                             isBusy={this.isSaving}
                             disabled={this.isFormDisabled}/>
            </MToolbar>
        );

    }

    private async close_Click(): Promise<void> {
        this.props.history.goBack();

        //User is leaving without saving data so cancel the new entry.
        const result = await this.m_requestClient.call((client) => client.cancelCreate(this.props.match.params.id));
        result.throwIfFailed();
    }

    private isNavigateDisabled(): boolean{
        if(this.m_locationValue !== null){
            return !this.m_locationValue.match(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}([-a-zA-Z0-9@:%_,.~#?&|//=]*)$/g);
        }

        return true;
    }

    private onNavigate_Click(): void {
        window.open(this.m_locationValue, '_blank', 'noopener,noreferrer');
    }

    /** */
    public render(): ReactElement {

        return (
            <MPage title={this.state.pageTitle}
                   subtitle={this.state.pageSubtitle}
                   locked={this.state.page.locked}
                   width={12}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}
                   ref={this.m_pageRef}>

                <MAlertDialog ref={this.m_alertDialogRef}/>

                <div style={{position: "fixed", left: 0, width: "66%", top: "200px", padding: "0 2rem"}}>
                    <div style={{overflowY: "scroll", overflowX: "hidden", maxHeight: 'calc(100vh - 260px)'}}>
                        <MForm formId={this.state.form.id}
                               initialValues={this.state.form.data}
                               validationSchema={this.state.form.validationSchema}
                               onBeforeSubmit={this.form_onBeforeSubmit}
                               onSubmit={this.form_onSubmit}
                               onAfterSubmit={this.form_onAfterSubmit}
                               onError={this.form_onError}>

                            <div className="formgrid grid">
                                <div className="col-12">

                                    <MFormSection title="General">
                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Estimate"
                                                               fieldName="estimate">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.EstimateMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Requestor"
                                                               fieldName="requestor">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.RequestorMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={true}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Exchange"
                                                               fieldName="exchange">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MAutoComplete id={fieldProps.field.name}
                                                                       fieldProps={fieldProps}
                                                                       disabled={false}
                                                                       className={fieldClasses}
                                                                       suggestions={this.context?.enums === null ? [] : this.context?.enums.exchangeList.map(e => e.name)}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Additional Ref"
                                                               fieldName="additionalRef">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.AdditionalRefMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Project Code"
                                                               fieldName="projectValue">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={false}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.state.projectList.map(project => ({
                                                                               value: project.id,
                                                                               label: project.code + ' - ' + project.name
                                                                           }))}
                                                                           initialValue={-1}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Type Of Works"
                                                               fieldName="workStream">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MDropDown<number> id={fieldProps.field.name}
                                                                           disabled={false}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.workStreams.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={-1}
                                                        />
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label="Estimated Days"
                                                               fieldName="estimatedDays">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={5}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>
                                    <MFormSection>
                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'SLA'}
                                                               fieldName={'slaType'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MDropDown<number> id="ProjectSelection"
                                                                           disabled={false}
                                                                           fieldProps={fieldProps}
                                                                           items={this.context?.enums === null ? [] : this.context?.enums.slaTypes.map((enumvalue) => {
                                                                               return {label: enumvalue.name, value: enumvalue.id};
                                                                           })}
                                                                           initialValue={-1}
                                                                           onChange={(newValue: MNullable<number>) =>  this.onSlaChange(fieldProps, newValue)}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-3">
                                            <MFormFieldControl label={'Due Date'} fieldName={'dueDate'}>
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MCalendar id={fieldProps.field.name}
                                                                   fieldProps={fieldProps}
                                                                   disabled={fieldProps.form.values.slaType !== 3 || this.isFormDisabled}
                                                                   className={fieldClasses}
                                                                   showTime={false}
                                                                   showButtonBar={false}
                                                                   minDate={new Date()}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="Work Description (please provide detail if no A55/Job pack is provided)"
                                                               fieldName="workDescription">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextArea id={fieldProps.field.name}
                                                                  maxLength={Request.WorkDescriptionMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}
                                                                   rows={5}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="Additional E-mail addresses"
                                                               fieldName={'addRecipients'}>

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextArea id={fieldProps.field.name}
                                                                   maxLength={Request.AddRecipientsMaxLength}
                                                                   readonly={false}
                                                                   fieldProps={fieldProps}
                                                                   disabled={this.isFormDisabled}
                                                                   className={fieldClasses}
                                                                   rows={5}
                                                        />
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>

                                    <MFormSection title="Files">
                                        <div className="col-12 md:col-12">
                                            <FileListControl parentId={this.props.match.params.id}
                                                             msalContext={this.props.msalContext}
                                                             selectionOnly={false}
                                            />
                                        </div>
                                    </MFormSection>

                                    <MFormSection title="Location">

                                        <div className="col-12 md:col-6">
                                            <MFormFieldControl label="Easting"
                                                               fieldName="easting">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={8}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={0}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-6">
                                            <MFormFieldControl label="Northing"
                                                               fieldName="northing">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <MNumericBox id={fieldProps.field.name}
                                                                     maxLength={8}
                                                                     fieldProps={fieldProps}
                                                                     disabled={this.isFormDisabled}
                                                                     className={fieldClasses}
                                                                     decimalPlaces={0}
                                                                     useGrouping={false}/>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-12">
                                            <MFormFieldControl label="Grid Reference URL"
                                                               fieldName="gridReference">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                                    return (
                                                        <React.Fragment>
                                                            <MTextBox id={fieldProps.field.name}
                                                                      maxLength={300}
                                                                      fieldProps={fieldProps}
                                                                      disabled={this.isFormDisabled}
                                                                      className={fieldClasses}
                                                                      onChange={e => this.m_locationValue = e.toString()}
                                                            />
                                                            <MButton
                                                                tooltip={'Browse address'}
                                                                icon={'pi pi-compass'}
                                                                disabled={this.isNavigateDisabled}
                                                                onClick={this.onNavigate_Click}
                                                            />
                                                        </React.Fragment>
                                                    );
                                                }}
                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>

                                    <MFormSection title="Address">
                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Address 1"
                                                               fieldName="address1">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.Address1MaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Address 2"
                                                               fieldName="address2">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.Address2MaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Address 3"
                                                               fieldName="address3">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.Address3MaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="City"
                                                               fieldName="city">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CityMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="County"
                                                               fieldName="county">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.CountyMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label="Postcode"
                                                               fieldName="postcode">

                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MTextBox id={fieldProps.field.name}
                                                                  maxLength={Request.PostcodeMaxLength}
                                                                  readonly={false}
                                                                  fieldProps={fieldProps}
                                                                  disabled={this.isFormDisabled}
                                                                  className={fieldClasses}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>

                                        <div className="col-12 md:col-4">
                                            <MFormFieldControl label=""
                                                               fieldName="getaddress">
                                                {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                                    return (
                                                        <MButton label="Get Address From Location"
                                                                 color="success"
                                                                 iconOnly={false}
                                                                 icon={MNavigateToIconName}
                                                                 disabled={fieldProps.form.values.easting < 100000
                                                                     || fieldProps.form.values.northing < 100000}
                                                                 isBusy={this.isSaving}
                                                                 onClick={e => this.getAddress_Click(fieldProps)}/>
                                                    );

                                                }}

                                            </MFormFieldControl>
                                        </div>
                                    </MFormSection>

                                </div>
                            </div>

                        </MForm>
                    </div>
                </div>

                <div style={{position: "fixed", left: "65%", width: "35%", top: "200px", padding: "0 0rem"}}>
                    <div style={{overflowY: "scroll", overflowX: "hidden", maxHeight: 'calc(100vh - 260px)'}}>
                        <MFormSection title="Notes">
                            <div className="col-12 md:col-12">
                                <NoteListControl parentId={this.props.match.params.id}
                                                 msalContext={this.props.msalContext}
                                />
                            </div>
                        </MFormSection>
                    </div>
                </div>

            </MPage>

        );

    }

    private get isFormDisabled(): boolean{
        return this.isSaving;
    }

    private get isSaving() {
        return (this.state.pageActions === PageActions.Saving);
    }
}

export default withMsal(withRouter(CreateRequestPage));
